import React from 'react';
import { ChartOption, CompareOfferBarChartData } from 'types/chart';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatDanjiAveragePriceTick } from 'utils/formatUtil';
import dayjs from 'dayjs';
import CompareOfferBarChartTooltip from 'components/tooltip/CompareOfferBarChartTooltip';

interface Props {
  data: CompareOfferBarChartData[];
  chartKey: string;
  chartOption: ChartOption;
  isVisibleDay: boolean;
}

function CompareOfferBarChart({
  data,
  chartKey,
  chartOption,
  isVisibleDay,
}: Props) {
  const { tooltipActive, xAxisProps, yAxisProps } = chartOption;

  return (
    <ResponsiveContainer
      key={chartKey}
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }}
    >
      <BarChart data={data}>
        <CartesianGrid vertical={false} stroke="#E6E6E6" />

        <XAxis
          dataKey="date"
          axisLine={{ stroke: 'none' }}
          padding={{ left: 10 }}
          interval={xAxisProps?.interval}
          tick={{
            fill: '#d7d7d7',
            fontSize: '0.6rem',
            fontWeight: 700,
          }}
          tickLine={false}
          tickFormatter={(value) => {
            const yearMonth = dayjs(value).format('YYYY-MM');
            const monthDay = dayjs(value).format(`MM-DD`);
            const index = data.findIndex((data) => data.date === value); // 현재 데이터의 인덱스를 가져옴
            // 이전 데이터의 년도를 가져옴
            const prevYear =
              index > 0 ? dayjs(data[index - 1].date).format('YYYY') : '';

            if (isVisibleDay) return monthDay;
            // 현재 데이터의 년도와 이전 데이터의 년도가 다를 경우에만 년도를 표시
            return yearMonth !== prevYear ? yearMonth : '';
          }}
        />
        <YAxis
          type="number"
          tickCount={yAxisProps?.tickCount}
          ticks={yAxisProps?.ticks}
          domain={yAxisProps?.domain}
          width={45}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => formatDanjiAveragePriceTick(value)}
          tick={{
            fill: '#d7d7d7',
            fontSize: '0.6rem',
            fontWeight: 700,
          }}
        />

        <Tooltip
          filterNull
          content={<CompareOfferBarChartTooltip isVisibleDay={isVisibleDay} />}
        />
        <ReferenceLine y={0} />
        <Bar dataKey="difference" strokeWidth={3} isAnimationActive={false}>
          {data.map((value) => (
            <Cell
              key={value.date}
              fill={
                value.difference && value.difference > 0 ? '#4584FF' : '#FE4A40'
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default CompareOfferBarChart;
